import React, { useEffect, useRef, useState } from "react";
import { Camera } from "lucide-react";
import { ACCEPT_ATTR, validateImageFile } from "../../utils/aadhaarImageHelpers";

const AadhaarImageBox = ({ title, hint, file, onChange, disabled, externalError = "" }) => {
  const inputRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!file) { setPreviewUrl(""); return; }
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const handleSelect = (e) => {
    const selected = e.target.files?.[0];
    e.target.value = "";
    if (!selected) return;
    const err = validateImageFile(selected);
    setError(err);
    if (!err) onChange(selected);
  };

  const shownError = error || externalError;

  return (
    <div className="w-full">
      <p className="text-center text-sm font-medium text-gray-800 mb-2">{title}</p>
      <input ref={inputRef} type="file" accept={ACCEPT_ATTR} onChange={handleSelect} className="hidden" />
      <button
        type="button"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
        className={`w-full h-32 rounded-xl border-2 border-dashed overflow-hidden flex flex-col items-center justify-center gap-1 transition ${
          shownError ? "border-red-400 bg-red-50" : "border-indigo-300 bg-indigo-50"
        } ${disabled ? "cursor-default opacity-70" : "hover:bg-indigo-100"}`}
      >
        {previewUrl ? (
          <img src={previewUrl} alt={title} className="h-full w-full object-contain" />
        ) : (
          <>
            <Camera className="h-7 w-7 text-indigo-500" strokeWidth={1.6} />
            <span className="text-xs font-semibold text-indigo-600">Click to upload image</span>
            <span className="text-[11px] text-gray-500">{hint}</span>
          </>
        )}
      </button>
      {shownError && <p className="text-red-600 text-xs mt-2 text-center">⚠️ {shownError}</p>}
    </div>
  );
};

export default AadhaarImageBox;